'use strict';

import {module} from '../app';
import { constantStrings } from "../constants/constantStrings";

module.service('statusHelpers', ['techpadConfig', function (techpadConfig) {
  let self = this;
  self.techpadSettings = techpadConfig.settings;

  self.getStatusName = function (status) {
    switch (status) {
      case constantStrings.worklistStatuses.New.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.New.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.New.statusAlias;
        }
      case constantStrings.worklistStatuses.SurveyStarted.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.SurveyStarted.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.SurveyStarted.statusAlias;
        }
      case constantStrings.worklistStatuses.SurveyFinished.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.SurveyFinished.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.SurveyFinished.statusAlias;
        }
      case constantStrings.worklistStatuses.ExamWaiting.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ExamWaiting.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ExamWaiting.statusAlias;
        }
      case constantStrings.worklistStatuses.ExamIncomplete.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ExamIncomplete.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ExamIncomplete.statusAlias;
        }
      case constantStrings.worklistStatuses.ExamInProgress.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ExamInProgress.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ExamInProgress.statusAlias;
        }
      case constantStrings.worklistStatuses.ExamPaused.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ExamPaused.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ExamPaused.statusAlias;
        }
      case constantStrings.worklistStatuses.ExamStopped.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ExamStopped.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ExamStopped.statusAlias;
        }
      case constantStrings.worklistStatuses.Finished.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.Finished.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.Finished.statusAlias;
        }
      case constantStrings.worklistStatuses.UltrasoundRequested.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.UltrasoundRequested.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.UltrasoundRequested.statusAlias;
        }
      case constantStrings.worklistStatuses.RISWaiting.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.RISWaiting.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.RISWaiting.statusAlias;
        }
      case constantStrings.worklistStatuses.TakeExam.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.TakeExam.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.TakeExam.statusAlias;
        }
      case constantStrings.worklistStatuses.ReviewComplete.status:
        try {
          const label = self.techpadSettings.WorklistStatusesConfigs.find(status => status.Status == constantStrings.worklistStatuses.ReviewComplete.status).Label;
          return label;
        } catch (error) {
          return constantStrings.worklistStatuses.ReviewComplete.statusAlias;
        }
      default:
        return '';
    }
  };

  self.WorklistImHereStatuses = [
    {
      ArrivalStatusName: "PatientArrived",
      ArrivalStatusLabel: "Patient is here!",
      ArrivalStatusIconClass: "error-color fa-exclamation-circle",
      ArrivalStatusMessageClass: "error-color"
    },
    {
      ArrivalStatusName: "ReadyForExam",
      ArrivalStatusLabel: "Patient notified!",
      ArrivalStatusIconClass: "success-color fa-check",
      ArrivalStatusMessageClass: "success-color"
    }
  ];

  self.GetImHereStatusMessage = function (ArrivalStatus) {
    return self.WorklistImHereStatuses.find(stat => stat.ArrivalStatusName === ArrivalStatus).ArrivalStatusLabel;
  };

  self.GetImHereStatusIconClass = function(ArrivalStatus){
    return self.WorklistImHereStatuses.find(stat => stat.ArrivalStatusName === ArrivalStatus).ArrivalStatusIconClass;
  }

  self.GetImHereStatusMessageClass= function(ArrivalStatus){
    return self.WorklistImHereStatuses.find(stat => stat.ArrivalStatusName === ArrivalStatus).ArrivalStatusMessageClass;
  }

  self.getColor = function (status) {
    const statusConfig = self.techpadSettings.WorklistStatusesConfigs.find(config => config.Status === status);
    if (statusConfig && statusConfig.Color) {
      return statusConfig.Color;
    }
    switch (status) {
      case constantStrings.worklistStatuses.New.status:
      case constantStrings.worklistStatuses.SurveyStarted.status:
      case constantStrings.worklistStatuses.SurveyFinished.status:
        return '#ffc900';
      case constantStrings.worklistStatuses.ExamWaiting.status:
        return "#ef473a";
      case constantStrings.worklistStatuses.ExamIncomplete.status:
      case constantStrings.worklistStatuses.ExamInProgress.status:
      case constantStrings.worklistStatuses.ExamPaused.status:
      case constantStrings.worklistStatuses.ExamStopped.status:
      case constantStrings.worklistStatuses.Finished.status:
        return '#886aea';
      default:
        return '#444';
    }
  };

  self.getIcon = function (status) {
    switch (status) {
      case constantStrings.worklistStatuses.New.status:
      case constantStrings.worklistStatuses.SurveyStarted.status:
      case constantStrings.worklistStatuses.SurveyFinished.status:
        return 'ion-ios-paper-outline';
      case constantStrings.worklistStatuses.ExamWaiting.status:
        return 'ion-ios-timer-outline'
      case constantStrings.worklistStatuses.ExamIncomplete.status:
      case constantStrings.worklistStatuses.ExamInProgress.status:
      case constantStrings.worklistStatuses.ExamPaused.status:
      case constantStrings.worklistStatuses.ExamStopped.status:
      case constantStrings.worklistStatuses.Finished.status:
      default:
        return 'ion-ios-pulse';
    }
  };

  self.getAdditionalInfoLabel = function (additionalInfo) {
    switch (additionalInfo) {
      case constantStrings.worklistAddditionalInfo.ReleasePatient.infoCode:
        return constantStrings.worklistAddditionalInfo.ReleasePatient.infoAlias;
      case constantStrings.worklistAddditionalInfo.AdditionalImaging.infoCode:
        return constantStrings.worklistAddditionalInfo.AdditionalImaging.infoAlias;
      case constantStrings.worklistAddditionalInfo.UltrasoundRequested.infoCode:
        return constantStrings.worklistAddditionalInfo.UltrasoundRequested.infoAlias;
      case constantStrings.worklistAddditionalInfo.Other.infoCode:
        return constantStrings.worklistAddditionalInfo.Other.infoAlias;
      default:
        return '';
    }
  }

}]);



// WEBPACK FOOTER //
// ./src/scripts/services/statusHelpers.js